import { Tabs } from '@mantine/core';
import type { FC } from 'react';
import { Container } from '@/DesignSystem/Component';
import { usePrepareTabData } from '@/Module/Teacher/Hook';
import style from './teacherDetailTab.module.scss';
const TeacherDetailTab: FC = () => {
  const {
    tabs,
    panel
  } = usePrepareTabData();
  if (!tabs.length) return null;
  return <Container data-sentry-element="Container" data-sentry-component="TeacherDetailTab" data-sentry-source-file="TeacherDetailTab.tsx">
      <Tabs aria-label="teacher-detail" defaultValue="سوابق تدریس" variant="pills" classNames={style} data-sentry-element="Tabs" data-sentry-source-file="TeacherDetailTab.tsx">
        <Tabs.List data-sentry-element="unknown" data-sentry-source-file="TeacherDetailTab.tsx">{tabs}</Tabs.List>
        {panel}
      </Tabs>
    </Container>;
};
export default TeacherDetailTab;